import { render, staticRenderFns } from "./settingUpdate.vue?vue&type=template&id=69d5341f&scoped=true"
import script from "./settingUpdate.vue?vue&type=script&lang=js"
export * from "./settingUpdate.vue?vue&type=script&lang=js"
import style0 from "./settingUpdate.vue?vue&type=style&index=0&id=69d5341f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d5341f",
  null
  
)

export default component.exports